// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_ds-0";